import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

const MOBILE_DEVICE_BIOMETRIC_AUTHENTICATION = createApiNamespacedConstants('MOBILE_DEVICE_BIOMETRIC_AUTHENTICATION');

export default {
  MOBILE_DEVICE_BIOMETRIC_AUTHENTICATION,
};
